import React from 'react'
import { urlPrefixes, UserType } from '../../../config/constants'
import LocaleText from '../../common/LocaleText'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import { useLocale, useSm, useTablet } from '../../hocs/hooks'
import styles from './RegisterGuest.scss'
import { getGlobalEnv } from '../../../helpers/coreUtil'
import GuestRegisterPC from '../../../assets/imgs/new-vanshare/guest_register_pc.png'
import GuestRegisterSP from '../../../assets/imgs/new-vanshare/guest_register_sp.png'
import { Link } from 'react-router-dom'

const RegisterGuest = () => {
  const locale = useLocale()
  const isSm = useSm()
  const isTablet = useTablet()

  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcMobilePC = getResponsiveSrcSetsFromWH(GuestRegisterPC, 1100, undefined, { webp: false, cdn })
  const srcMobileSP = getResponsiveSrcSetsFromWH(GuestRegisterSP, 335, undefined, { webp: false, cdn })

  return <>
    {!(isSm || isTablet) ? <div className={styles.container}>
        <ResponsiveImg
          url={GuestRegisterPC}
          caption="Carstayアプリでサクサク予約"
          srcSet={srcMobilePC}
        />
        <Link className={['btn', 'btn-primary', styles.registerButton].join(' ')}
          to={`/${locale}${urlPrefixes[UserType.user]}/signup/`}
        >
          <LocaleText ja="ゲスト登録する" en="Register guest" />
        </Link>
      </div>
      : <div className={styles.container}>
        <ResponsiveImg
          url={GuestRegisterSP}
          caption="Carstayアプリでサクサク予約"
          srcSet={srcMobileSP}
        />
        <Link className={['btn', 'btn-primary', styles.registerButton].join(' ')}
          to={`/${locale}${urlPrefixes[UserType.user]}/signup/`}
        >
          <LocaleText ja="ゲスト登録する" en="Register guest" />
        </Link>
      </div>
    }
  </>
}
RegisterGuest.displayName = 'RegisterGuest'
export default RegisterGuest
